// Search
// -> Sends a request to a php parcel search and returns matches
// -> Supports auto search or search on button press

// Import Esri Components
// import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";
import * as query from "@arcgis/core/rest/query.js";
import Query from "@arcgis/core/rest/support/Query.js";
// import QueryTask from "@arcgis/core/tasks/QueryTask";

import React from "react";

// Functions
// import { buildResizeContainer } from "../Resize";

// Import Semantic UI React
import { Menu, Icon, List, Input } from "semantic-ui-react";

export default class SearchWidget extends React.Component {
  constructor(props) {
    super();

    // console.log({ props });

    this.state = {
      term: "",
      active: false,
      selected: "address",
      parcel: [],
      owner: [],
      address: [],
      results: [],
      loading: false,
      button_loading: false,
    };

    this.timeout_handler = null;
    this.autoSearchHandler = this.autoSearchHandler.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  // Handles the search input
  // => clears if the user is still typing
  autoSearchHandler(event) {
    const term = event.target.value;

    if (this.timeout_handler) {
      clearTimeout(this.timeout_handler);
    }

    this.setState({ term: term }, () => {
      this.timeout_handler = setTimeout(() => {
        if (term.length > 3) {
          this.setState({ loading: true }, () => {
            this.fetchTerm();
          });
        }
      }, 500);
    });
  }

  // Handles the menu button clicks to change the list
  menuClickHandler(key) {
    this.setState({
      selected: key,
    });
  }

  // Key listener on the search input so user doesn't have to click on the submit button
  onKeyDown(event) {
    if (event.key === "Enter" && this.state.term.length > 2) {
      this.submitHandler();
    }
  }

  // Handles the search submit
  submitHandler() {
    if (this.state.term) {
      this.setState({ button_loading: true }, () => {
        this.queryParcels();
      });
    }
  }

  // Build fetchTerm to send to the Service to get feature
  searchItemClick(record) {
    // console.log("searchItemClick", { record });
    // Add the selected record before querying to show feedback
    this.setState(
      {
        selected_record: record.key,
      },
      () => {
        this.queryParcels(record);
      }
    );
  }

  queryParcels(record) {
    console.log("queryParcels", record);
    // create the Query
    const queryObj = new Query();
    queryObj.returnGeometry = true;
    queryObj.outFields = ["*"];
    if (record) {
      queryObj.where = `${record.field} = '${record.value}'`;
    } else {
      queryObj.where = `ParcelNumb LIKE UPPER('%${this.state.term}%') OR PARCEL_NO LIKE UPPER('%${this.state.term}%') OR OwnerName LIKE UPPER('%${this.state.term}%') OR FullSitus LIKE UPPER('%${this.state.term}%')`;
    }

    // this.queryTask.execute(query).then((results) => {
    query.executeQueryJSON(this.props.service, queryObj).then((result) => {
      console.log("queryTaskResults", result);

      var obj = {
        feature: result.features[0],
        layerName: "Parcels",
      };

      // zoom to extent
      this.props.zoomToExtent(obj.feature)

      // render the popup
      this.props.renderPopup([obj]);

      // check if should return the geometry or use the default method
      if (this.props.result_callback) {
        this.props.result_callback(results);
        this.setState(
          {
            button_loading: false,
            selected_record: null,
          }
        );
      } else {
        this.setState({
          button_loading: false,
          results: result.features,
          selected_record: null,
        });
      }
    });
  }

  resultItemClick(feature) {
    // Clear the Graphics
    this.props.view.graphics.removeAll();

    // Create the graphics
    const graphic = new Graphic({
      geometry: feature.geometry,
      symbol: {
        type: "simple-fill",
        outline: {
          width: 2,
          color: [255, 0, 0, 1],
          cap: "round",
          join: "round",
        },
        color: [255, 255, 255, 0],
      },
    });
    this.props.view.graphics.add(graphic);

    // expand the extent and override the spatial reference because esri sucks
    var ext = feature.geometry.extent.clone().expand(1.25);
    ext.spatialReference.wkid = 3418;

    // Zoom to the extent
    this.props.view.goTo(ext);
  }

  returnToSearch() {
    this.setState({
      results: [],
    });
  }

  // Clears the search box
  clearTextHandler() {
    this.setState({
      term: "",
      active: false,
      parcel: [],
      owner: [],
      address: [],
      results: [],
    });
  }

  // Queries the database for terms
  fetchTerm = () => {
    var term = this.state.term.toUpperCase();

    // Query the Address field
    const queryAddress = new Query();
    queryAddress.returnGeometry = false;
    queryAddress.outFields = ["FullSitus"];
    queryAddress.where = `UPPER(FullSitus) LIKE '%${term}%'`;
    queryAddress.orderByFields = ["FullSitus DESC"];

    // Query the Owner Field
    const queryOwner = new Query();
    queryOwner.returnGeometry = false;
    queryOwner.outFields = ["OwnerName"];
    queryOwner.where = `UPPER(OwnerName) LIKE '%${term}%'`;
    queryOwner.orderByFields = ["OwnerName DESC"];

    // Query the PARCEL_NO Field
    const queryParcelNO = new Query();
    queryParcelNO.returnGeometry = false;
    queryParcelNO.outFields = ["PARCEL_NO"];
    queryParcelNO.where = `UPPER(PARCEL_NO) LIKE '%${term}%'`;
    queryParcelNO.orderByFields = ["PARCEL_NO DESC"];

    // Query the PARCELNUMB Field
    const queryParcelNumb = new Query();
    queryParcelNumb.returnGeometry = false;
    queryParcelNumb.outFields = ["ParcelNumb"];
    queryParcelNumb.where = `UPPER(ParcelNumb) LIKE '%${term}%'`;
    queryParcelNumb.orderByFields = ["ParcelNumb DESC"];

    const compare = (a, b) => {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    };

    Promise.all([
      query.executeQueryJSON(this.props.service, queryAddress),
      query.executeQueryJSON(this.props.service, queryOwner),
      query.executeQueryJSON(this.props.service, queryParcelNO),
      query.executeQueryJSON(this.props.service, queryParcelNumb),
    ]).then((result) => {
      var selected_list = null;

      const data = {
        address: result[0].features
          .map((record) => {
            return {
              value: record.attributes.FullSitus,
              field: "FullSitus",
              key: this.generateKey(),
            };
          })
          .sort(compare),
        owner: result[1].features
          .filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                (t) => t.attributes.OwnerName === thing.attributes.OwnerName
              )
          )
          .map((record) => {
            return {
              value: record.attributes.OwnerName,
              field: "OwnerName",
              key: this.generateKey(),
            };
          })
          .sort(compare),
      };

      // concat the parcels results
      var parcels = result[2].features
        .map((record) => {
          return {
            value: record.attributes.PARCEL_NO,
            field: "PARCEL_NO",
            key: this.generateKey(),
          };
        })
        .concat(
          result[3].features.map((record) => {
            return {
              value: record.attributes.ParcelNumb,
              field: "ParcelNumb",
              key: this.generateKey(),
            };
          })
        );

      // add teh parcels to the data object and sort them
      data.parcel = parcels.sort(compare);

      // Determine which list to be selected
      // => default order is address, then owner, then parcels
      if (data.address.length > 0) {
        selected_list = "address";
      } else if (data.owner.length > 0) {
        selected_list = "owner";
      } else if (data.parcel.length > 0) {
        selected_list = "parcel";
      }

      this.setState(
        {
          parcel: data.parcel,
          address: data.address,
          owner: data.owner,
          selected: selected_list,
          loading: false,
          button_loading: false,
          active: true,
        }
      );
    });
  };

  generateKey() {
    return new Date().valueOf() + Math.floor(Math.random() * 1000000);
  }

  render() {
    // console.log("SearchWidget", { state: this.state, props: this.props });
    return (
      <React.Fragment>
        <div>
          {this.renderSearch()}
          {this.renderMenu()}
        </div>
        <div className="ui resize-scroll no-margin segment">
          {this.renderList()}
        </div>
      </React.Fragment>
    );
  }

  // Builds the menu button for user to change the list
  renderMenu() {
    // console.log("RENDER MENU", this.state);

    // if (this.state.results.length > 0) {
    //   return null;
    // }

    var lists = [
      this.state.parcel.length,
      this.state.owner.length,
      this.state.address.length,
    ];

    // Convert the number of records in the lists greater than zero, then convert that to a string for a class
    var number_of_menu_options = lists.filter((list) => list > 0);

    switch (number_of_menu_options.length) {
      case 1:
        number_of_menu_options = "one";
        break;
      case 2:
        number_of_menu_options = "two";
        break;
      case 3:
        number_of_menu_options = "three";
        break;
      default:
        number_of_menu_options = null;
        break;
    }

    if (number_of_menu_options) {
      return (
        <Menu
          style={{ borderRadius: 0 }}
          className={`resize-block no-margin ui ${number_of_menu_options} item`}
        >
          {lists[2] > 0 && (
            <Menu.Item
              active={this.state.selected === "address"}
              onClick={() => this.menuClickHandler("address")}
            >
              Address
            </Menu.Item>
          )}
          {lists[1] > 0 && (
            <Menu.Item
              active={this.state.selected === "owner"}
              onClick={() => this.menuClickHandler("owner")}
            >
              Owner
            </Menu.Item>
          )}
          {lists[0] > 0 && (
            <Menu.Item
              active={this.state.selected === "parcel"}
              onClick={() => this.menuClickHandler("parcel")}
            >
              Parcels
            </Menu.Item>
          )}
        </Menu>
      );
    } else {
      return null;
    }
  }

  // Builds the list based on the selected menu item
  renderList() {
    // Render default message if not active
    if (!this.state.active) {
      return <p>Search by Owner, Address, or Parcel Number</p>;
    }

    // If there is no result but active then render no results
    if (!this.state.selected || this.state[this.state.selected].length === 0) {
      return (
        <p>
          <b>No Results Found</b>
        </p>
      );
    }

    // Render the results of the search as default
    return (
      <List divided relaxed>
        {this.state[this.state.selected].map((record, index) => {
          // console.log(record, index);
          return (
            <List.Item
              style={{ cursor: "pointer" }}
              key={index}
              disabled={record.key === this.state.selected_record}
              onClick={() => this.searchItemClick(record)}
            >
              <List.Icon
                loading={
                  this.state.selected_record &&
                  this.state.selected_record === record.key
                }
                className="middle aligned no-padding icon"
                name={
                  this.state.selected_record &&
                  this.state.selected_record === record.key
                    ? "notched circle"
                    : "caret right"
                }
              />
              <List.Content>
                <p>{record.value}</p>
              </List.Content>
            </List.Item>
          );
        })}
      </List>
    );
  }

  // Renders the appropriate search method based on the props
  // -> default is button
  renderSearch = () => {
    if (!this.props.search_type || this.props.search_type === "button") {
      var clearTextIcon = null;
      if (this.state.term && this.state.term.length > 0) {
        clearTextIcon = (
          <Icon
            link
            id="clear_search_btn"
            className="middle aligned no-padding icon"
            name={"delete"}
            style={{ right: "38px", cursor: "pointer" }}
            onClick={() => this.clearTextHandler()}
          />
        );
      }

      return (
        <Input
          fluid
          value={this.state.term}
          onChange={this.autoSearchHandler}
          onKeyDown={this.onKeyDown}
          label={
            <button
              id="search_all_button"
              style={{ borderRadius: 0 }}
              className={
                this.state.term.length > 2
                  ? `ui icon ${
                      this.state.button_loading ? "loading" : ""
                    } button`
                  : `ui icon disabled ${
                      this.state.button_loading ? "loading" : ""
                    }button`
              }
              onClick={() => this.submitHandler()}
              data-content="Search Parcels by matching term (minimum 3 characters)"
            >
              <i className="search icon" />
            </button>
          }
          labelPosition="right"
          icon={clearTextIcon}
        />
      );
    }
  };
}
